import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpclientService } from "./services/httpclient.service";
import { LocalstorageService } from "./services/localstorage.service";
import { LoggerService } from "./services/logger.service";
import { UserService } from "./services/user.service";
import { SchoolService } from "./services/school.service";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { PreferenceService } from "./services/preference.service";
import { FacilityService } from "./services/facility.service";
import { TableModule } from "primeng/table";
import { CustomTooltipModule } from "./custom-tool-tip/custom-tool-tip.component";
@NgModule({
	imports: [CommonModule, FormsModule, ScrollPanelModule, TableModule, CustomTooltipModule],
	providers: [HttpclientService, LocalstorageService, LoggerService, UserService, SchoolService, FacilityService, PreferenceService, FacilityService],
	declarations: [],
})
export class AppSharedModule {}
